import { render } from "./FavoriteSkeleton.vue?vue&type=template&id=7fd662fb&scoped=true"
const script = {}

import "./FavoriteSkeleton.vue?vue&type=style&index=0&id=7fd662fb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fd662fb"]])

export default __exports__